import {
  DashboardOutlined,
  SettingOutlined,
  UserOutlined,
  CloudServerOutlined,
  FolderOpenOutlined,
  CalendarOutlined,
  ScheduleOutlined,
  TeamOutlined,
  FileTextOutlined,
  FileDoneOutlined,
  DollarOutlined,
} from '@ant-design/icons';
import { APP_PREFIX_PATH } from 'configs/AppConfig'

// Resource constants (must match backend)
export const RESOURCES = {
  DASHBOARD: 'dashboard',
  USERS: 'users',
  DOCUMENTS: 'documents',
  BACKUPS: 'backups',
  BOOKINGS: 'bookings',
  CUSTOMERS: 'customers',
  ESTIMATES: 'estimates',
  INVOICES: 'invoices',
  PAYMENTS: 'payments',
};

// Dashboard
const dashboardNavTree = [{
  key: 'dashboard',
  path: `${APP_PREFIX_PATH}/dashboard`,
  title: 'Dashboard',
  icon: DashboardOutlined,
  breadcrumb: false,
  isGroupTitle: true,
  submenu: [
    {
      key: 'app-dashboard',
      path: `${APP_PREFIX_PATH}/dashboard`,
      title: 'Dashboard',
      icon: DashboardOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.DASHBOARD, action: 'read' }
    },
  ]
}];

// Operations - Appointments, calendar, customers
const operationsNavTree = [{
  key: 'operations',
  path: `${APP_PREFIX_PATH}/bookings`,
  title: 'Operations',
  icon: ScheduleOutlined,
  breadcrumb: false,
  isGroupTitle: true,
  submenu: [
    {
      key: 'app-bookings',
      path: `${APP_PREFIX_PATH}/bookings`,
      title: 'Appointments',
      icon: ScheduleOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.BOOKINGS, action: 'read' }
    },
    {
      key: 'app-calendar',
      path: `${APP_PREFIX_PATH}/calendar`,
      title: 'Calendar',
      icon: CalendarOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.BOOKINGS, action: 'read' }
    },
    {
      key: 'app-customers',
      path: `${APP_PREFIX_PATH}/customers`,
      title: 'Customers',
      icon: TeamOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.CUSTOMERS, action: 'read' }
    },
  ]
}];

// Sales - Estimates, invoices, payments
const salesNavTree = [{
  key: 'sales',
  path: `${APP_PREFIX_PATH}/estimates`,
  title: 'Sales & Billing',
  icon: DollarOutlined,
  breadcrumb: false,
  isGroupTitle: true,
  submenu: [
    {
      key: 'app-estimates',
      path: `${APP_PREFIX_PATH}/estimates`,
      title: 'Estimates & Quotes',
      icon: FileTextOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.ESTIMATES, action: 'read' }
    },
    {
      key: 'app-invoices',
      path: `${APP_PREFIX_PATH}/invoices`,
      title: 'Invoices',
      icon: FileDoneOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.INVOICES, action: 'read' }
    },
    {
      key: 'app-payments',
      path: `${APP_PREFIX_PATH}/payments`,
      title: 'Payments',
      icon: DollarOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.PAYMENTS, action: 'read' }
    },
  ]
}];

// Administration group - User management, file manager, backups
const adminNavTree = [{
  key: 'administration',
  path: `${APP_PREFIX_PATH}/admin`,
  title: 'Administration',
  icon: SettingOutlined,
  breadcrumb: false,
  isGroupTitle: true,
  submenu: [
    {
      key: 'app-users',
      path: `${APP_PREFIX_PATH}/admin/users`,
      title: 'User Management',
      icon: UserOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.USERS, action: 'read' }
    },
    {
      key: 'app-file-manager',
      path: `${APP_PREFIX_PATH}/admin/file-manager`,
      title: 'File Manager',
      icon: FolderOpenOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.DOCUMENTS, action: 'read' },
    },
    {
      key: 'app-backups',
      path: `${APP_PREFIX_PATH}/admin/backups`,
      title: 'Backup & Restore',
      icon: CloudServerOutlined,
      breadcrumb: false,
      submenu: [],
      adminOnly: true, // Only visible to admins
    }
  ]
}];

const navigationConfig = [
  ...dashboardNavTree,
  ...operationsNavTree,
  ...salesNavTree,
  ...adminNavTree,
]

export default navigationConfig;
